<template>
  <el-main>
    <banner></banner>
    <ad-show-styles></ad-show-styles>
    <get-more></get-more>
  </el-main>
</template>

<script>
import Banner from '../../components/Banner'
import AdShowStyles from '@/pages/adStyle/components/AdShowStyles'
import GetMore from '../../components/GetMore'

export default {
  name: 'AdStyle',
  components: {
    Banner,
    AdShowStyles,
    GetMore
  }
}
</script>

<style scoped lang="stylus">
  .el-main
    padding: 20px 0
</style>



// WEBPACK FOOTER //
// src/pages/adstyle/AdStyle.vue